import * as React from "react";

function SvgHeading5(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}><path d="M7.7 12.1H6.3V8.4H2.4v3.8H1V3.8h1.4v3.4h3.9V3.8h1.4v8.3zM12.2 6.9c.9 0 1.5.2 2 .7.5.4.8 1 .8 1.8 0 .9-.3 1.6-.9 2.1-.6.5-1.4.7-2.4.7-.9 0-1.7-.1-2.2-.4v-1.2c.3.2.7.3 1.1.4.4.1.8.1 1.1.1.6 0 1.1-.1 1.4-.4.3-.3.5-.7.5-1.2 0-1-.6-1.5-1.9-1.5H11c-.3 0-.5.1-.7.1l-.7-.3.4-4h4.4V5h-3.2L11 7.1c.1 0 .3 0 .5-.1.2 0 .4-.1.7-.1z" /></svg>;
}

export default SvgHeading5;